import ImageContentBlock from "./functional";
export default ImageContentBlock;
